import { Button } from '@nike/eds'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from '@nike/nike-design-system-icons'

export function BackButton({ style = undefined, ...otherProps }) {
  const navigate = useNavigate()

  return (
    <Button
      style={{ marginRight: 'var(--eds-space-24)', display: 'inline-flex', ...style }}
      onClick={() => navigate(-1)}
      {...otherProps}
    >
      <ArrowLeft />
    </Button>
  )
}
